import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=5853ca4f&scoped=true&"
import script from "./InfoList.vue?vue&type=script&lang=js&"
export * from "./InfoList.vue?vue&type=script&lang=js&"
import style0 from "./InfoList.vue?vue&type=style&index=0&id=5853ca4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853ca4f",
  null
  
)

export default component.exports